import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=fa37f32a"
import script from "./Competitor.vue?vue&type=script&lang=js"
export * from "./Competitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports